export const planogramDeliveryEn = {
  previewPdf: {
    button: "Preview PDF",
    searchPlaceholder: "Search delivery history",
    mostRecent: "Most recent (auto)",
    noResults: "No matching deliveries found.",
  },
  markDelivered: {
    action: "Mark as delivered",
    approveFirstTooltip: "Approve this planogram first to mark it as delivered",
    toastDelivered: "Marked as delivered",
    toastAlreadyDelivered: "This planogram was already marked as delivered",
    bulkAction: "Mark all as delivered",
    bulkSummary: "{{delivered}} marked as delivered · {{alreadyDelivered}} already delivered",
    bulkSkippedSuffix: " · {{skipped}} skipped — not yet approved",
    showSkipped: "Show skipped stores",
    hideSkipped: "Hide skipped stores",
    skippedStores: "Skipped stores: {{stores}}",
    conflictTitle: "Two delivered planograms for one go-live date",
    conflictDescription:
      "Marking this as delivered gives these stores two delivered planograms going live on the same date. If you go ahead, the one you are delivering replaces the other:",
    conflictRow:
      "Store {{store}} · {{category}}: from {{date}} it shows {{merchflow}}; {{deliveredMerchflow}} (POG {{storePogId}}) moves to Historical",
    conflictMore: "…and {{count}} more",
    conflictUnknownMerchflow: "unknown merchflow",
    conflictCheckFailed: "Could not check for delivery conflicts",
    conflictCancel: "Cancel",
    conflictDeliverAnyway: "Mark as delivered anyway",
  },
  itemSummary: {
    noDeliveryHistory:
      "No previous delivery on record for this store/category — every item below is shown as newly added.",
    comparisonError:
      "Could not load the requested comparison delivery — every item below is shown as newly added.",
  },
  deleteMerchflow: {
    deletedToast: 'Merchflow "{{name}}" deleted successfully',
    confirmTitle: 'Delete "{{name}}"?',
    confirmDescriptionSingular:
      "This merchflow has {{count}} planogram delivery recorded. Deleting it will permanently remove that delivery history too. This action cannot be undone.",
    confirmDescriptionPlural:
      "This merchflow has {{count}} planogram deliveries recorded. Deleting it will permanently remove that delivery history too. This action cannot be undone.",
    deleteAnyway: "Delete anyway",
  },
  jdaImport: {
    modalTitle: "JDA Baseline Import — {{categoryCode}}",
    roleLabels: {
      site: "JDA Site",
      shelf: "JDA Shelf",
      articleMaster: "Article Master",
    },
    notYetAdded: "not yet added",
    couldntIdentifySingular: "Couldn't identify this file — please choose which one it is:",
    couldntIdentifyPlural: "Couldn't identify these files — please choose which one it is:",
    chooseType: "Choose type",
    batchDate: "Batch date",
    resultSummary:
      "Imported {{imported}} baseline(s), skipped {{skippedEmpty}} empty pair(s), skipped {{skippedExisting}} already-imported pair(s).",
    upload: "Upload",
    categoriesActionLabel: "JDA BASELINE",
    categoriesDisabledTooltip: "Enable JDA import for this merchant in Settings first",
  },
  pdfExport: {
    loading: "Loading PDF export...",
    loadError: "Failed to load PDF export data.",
    missingCategory: "Cannot export PDF because the category is missing.",
    exclusionsError: "Failed to load PDF summary exclusions.",
  },
  pdfSummaryExclusions: {
    modalTitle: "PDF Summary Exclusions — {{categoryCode}}",
    description: "Upload a CSV to replace the category's current PDF summary exclusions.",
    fileLabel: "PDF Summary Exclusions",
    success: "Saved {{count}} excluded product code(s).",
    invalidCsv:
      "CSV must contain one PRODUCT_CODE column; product codes must be non-empty, at most 256 characters, and contain no commas. Remove commas and try again.",
    upload: "Upload",
    downloadSample: "Download sample",
    downloadCurrentList: "Download current list",
    categoriesActionLabel: "PDF SUMMARY EXCLUSIONS",
  },
  variantRestrictionDescribe: {
    categoriesActionLabel: "VARIANT RESTRICTION (DESCRIBE)",
    modalTitle: "Describe variant restrictions — {{categoryCode}}",
    descriptionTitle: "Describe the rules in plain English",
    placeholder:
      "Keep alcohol off the top two shelves in stores 1023 and 1044. Coca-Cola must be on the bottom shelf everywhere.",
    appendHelp:
      'Describe another set and add it — or add to a group by name (e.g. "add COOKIES to Group 1").',
    replaceAll: "Replace all",
    addToRules: "Add to rules",
    generateRules: "Generate rules",
    reviewRules: "Review before saving — each rule targets a bay and shelf (use * for all)",
    noRules: "No rules yet — add them by hand below",
    summary: "Summary",
    described: "Described:",
    translatedTo: "Translated to:",
    addedManually: "Added by hand",
    noRulesForDescription: "(no rules)",
    everyBay: "all bays",
    everyShelf: "all shelves",
    addStoreGroup: "Add store group",
    replaceRestrictions: "Replace restrictions",
    missingRuleFields: "Every rule needs a variant, a bay, and a shelf before saving.",
    resolveStoreCodes: "Resolve or clear the unrecognised store codes before saving.",
    resolveVariants:
      "Resolve each unmatched variant (use the suggestion or “Keep as typed”) before saving.",
    loadingStoreScope: "Loading store scope… saving is disabled until it loads.",
    storeScopeLoadError: "Couldn’t load the store scope, so saving is disabled.",
    retry: "Retry",
    loadingRacks: "Loading the category’s racks… named Rack choices appear once they load.",
    racksLoadError: "Couldn’t load the category’s racks, so named Rack choices are missing.",
    savingReplaces: "Saving replaces all existing variant restrictions for this category.",
    confirmReplaceTitle: "Replace all current rules?",
    confirmReplaceDescription:
      "This discards the rules and edits you have now and re-parses from the description.",
    confirmApplyTitle: "Replace variant restrictions for {{categoryCode}}?",
    confirmApplyDescription:
      "This replaces all existing variant restrictions for this category, including any imported from CSV. This can't be undone.",
    back: "Back",
    replace: "Replace",
    savedTitle: "Variant restrictions saved",
    parseFailedTitle: "Couldn't read those restrictions",
    parseFailedMessage: "Try rephrasing, or add the rules by hand below.",
    loadStoreFiltersFailed: "Failed to load store filters",
    saveFailedTitle: "Failed to save variant restrictions",
    groupName: "Group {{index}}",
    removeStoreGroupAriaLabel: "Remove store group",
    appliesToStores: "Applies to stores",
    storeCodesPlaceholder: "Store codes, comma separated — leave blank for all stores",
    parsedFilterUnavailable: "Parsed store filter (attribute options unavailable):",
    noStoreFilters: "No store filters available for this category.",
    filterStoresByAttribute:
      "Or filter stores by attribute (matched stores are added to the scope):",
    baySize: "Bay size",
    state: "State",
    cluster: "Cluster",
    sectionHeight: "Section height",
    sectionWidth: "Section width",
    any: "Any",
    appliesToAllStore: "Applies to the only store in the category",
    appliesToAllStores: "Applies to all {{count}} stores in the category",
    appliesToStore: "Applies to 1 store",
    appliesToStoresCount: "Applies to {{count}} stores",
    unrecognisedStore: "Unrecognised store: {{stores}}",
    unrecognisedStores: "Unrecognised stores: {{stores}}",
    addRule: "Add rule",
    condition: "Condition",
    conditionMustHave: "Must have",
    conditionMayHave: "May have",
    conditionOnlyThese: "Only these",
    conditionMustNotHave: "Must not have",
    variant: "Variant",
    bay: "Bay",
    shelf: "Shelf",
    all: "All",
    allBaysAriaLabel: "All bays",
    allShelvesAriaLabel: "All shelves",
    shelfOptionRack: "Rack (any rack)",
    shelfOptionNotRack: "Not rack (wall shelves)",
    shelfOptionAll: "* (all shelves)",
    shelfOptionRackNamed: "Rack: {{name}}",
    shelfOptionNotRackNamed: "Not rack: {{name}}",
    shelfOptionTop: "Top",
    shelfOptionBottom: "Bottom",
    rackRuleAnyRack: "racks",
    rackRuleEverywhereBut: "every shelf but {{name}}",
    rackRuleWallShelves: "the wall shelves",
    rackRuleMustHave: "{{variant}}: must be on {{target}}",
    rackRuleMayHave: "{{variant}}: may go on {{target}}",
    rackRuleOnlyThese: "{{variant}}: the only variants on {{target}}",
    rackRuleMustNotHave: "{{variant}}: never on {{target}}",
    rackRuleOnlyOn: "{{variant}}: only on {{target}}",
    removeRuleAriaLabel: "Remove rule",
    noExactVariantMatch: "No exact variant match.",
    needsReview: "Needs review before saving.",
    useSuggestion: "Use “{{suggestion}}”",
    keepAsTyped: "Keep as typed",
    setBayAndShelf:
      "Set a bay and shelf (e.g. bay “1”, shelf “Top”). Use “*” for every bay or every shelf.",
    conflictsTitle: "Conflicting rules",
    conflictsHelp:
      "These rules contradict each other on the same shelves, so both can't be applied. Select which rule to keep — the other is removed.",
    conflictRequiredAndForbidden:
      "“{{variant}}” is both required and forbidden on overlapping shelves.",
    conflictOutsideAllowedSet:
      "“{{variant}}” is required on a shelf whose allowed variants don't include it.",
    conflictAllowedAndForbiddenOnRack:
      "“{{variant}}” is both allowed and forbidden on the same rack.",
    keepThisRule: "Keep this rule",
    conflictsWithAnotherRule: "Conflicts with another rule — see “Conflicting rules” below.",
    resolveConflicts: "Resolve the conflicting rules (keep one of each pair) before saving.",
  },
} as const;

export type PlanogramDeliveryTranslations = typeof planogramDeliveryEn;
